<template>
  <v-overlay
      :value="value"
      v-bind="$attrs"
  >
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "TsCircleLoader",
  props:['value']
}
</script>

<style scoped>

</style>